import { DqEmptyData, DqLoader } from "@decentriq/components";
import { Grid } from "@mui/joy";
import { memo } from "react";

interface EntitiesGridProps<T> {
  data: T[];
  emptyMessage: string;
  isLoading: boolean;
  renderItem: (item: T) => React.ReactNode;
}

const EntitiesGrid = memo(
  <T extends { id: string }>({
    data,
    emptyMessage,
    isLoading,
    renderItem,
  }: EntitiesGridProps<T>) => {
    if (isLoading) {
      return (
        <DqLoader
          sx={{
            alignItems: "center",
            display: "flex",
            height: "100%",
            justifyContent: "center",
            width: "100%",
          }}
        />
      );
    }
    if (data.length === 0) {
      return <DqEmptyData title={emptyMessage} />;
    }
    return (
      <Grid container={true} spacing={2}>
        {data.map((item) => (
          <Grid key={item.id} md={3} sm={6} sx={{ cursor: "pointer" }} xs={12}>
            {renderItem(item)}
          </Grid>
        ))}
      </Grid>
    );
  }
);

EntitiesGrid.displayName = "EntitiesGrid";

export default EntitiesGrid;
